export interface IDonationFund {
  id: number;
  active: boolean | null; // single character
  displayOrder: number | null;
  letterText: string | null;
  showInCheckout: boolean | null; // single character
  isEndowment: boolean | null; // single character
  portalDescription: string | null;
  fundName: string | null;
}

export class DonationFund implements IDonationFund {
  id;
  active;
  displayOrder;
  letterText;
  showInCheckout;
  isEndowment;
  portalDescription;
  fundName;

  constructor(config: IDonationFund) {
    this.id = config.id;
    this.active = config.active;
    this.displayOrder = config.displayOrder;
    this.letterText = config.letterText;
    this.showInCheckout = config.showInCheckout;
    this.isEndowment = config.isEndowment;
    this.portalDescription = config.portalDescription;
    this.fundName = config.fundName;
  }
}
